import React from "react";
import { BillDetailsProvider, BillEnquiryProvider } from "./allContext";

//reduceRight executes a reducer function for each array element 
function ProviderComposer({ contexts, children }: any) {
  return contexts.reduceRight(
    (kids: any, parent: any) =>
      React.cloneElement(parent, {
        children: kids,
      }),
    children,
  );
}

function ContextProvider({ children }: any) {
  return (
    <ProviderComposer contexts={[<BillDetailsProvider />,<BillEnquiryProvider />]}>
      {children}
    </ProviderComposer>
  );
}

export { ContextProvider };
